import React from "react";

const NailExtensionBangaloreProcess = () => {
  return (
    <div className="nailExtensionMaintain">
      <h5>
        Step-by-Step Process of Getting Nail Extensions in Bangalore at SCENT
      </h5>
      <p>
        Curious about the process of getting nail extensions in Bangalore at
        SCENT? Here’s what you can expect:
      </p>
      <ul>
        <li>
          <h6>1. Consultation:</h6> Our technicians will discuss your preferred
          nail length, shape, and design to ensure we deliver results that meet
          your vision.
        </li>
        <li>
          <h6>2. Preparation:</h6> We start by cleaning and shaping your natural
          nails, ensuring a smooth foundation for the extensions.
        </li>
        <li>
          <h6>3. Application:</h6> Depending on the type of nail extension you
          choose, our technicians will apply the extensions with precision,
          ensuring they align perfectly with your natural nails.
        </li>
        <li>
          <h6>4. Shaping and Finishing:</h6> Once the extensions are set, we
          shape them to your desired length and style. A finishing touch is
          added with a top coat for shine and durability.
        </li>
        <li>
          <h6>5. Final Look and Care Tips:</h6> Our experts will provide
          aftercare advice to help you maintain your nail extensions in
          Bangalore and keep them looking flawless.
        </li>
      </ul>
    </div>
  );
};

export default NailExtensionBangaloreProcess;
